import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/User/Login'
import DashboardView from '@/components/User/DashboardView'
import ProfileView from '@/components/User/ProfileView'
import DashboardLayout from '@/components/Layout/DashboardLayout'
import UserList from '@/components/Admin/UserList'
import AseguradoraList from '@/components/Admin/AseguradoraList'
import AsesorList from '@/components/Admin/AsesorList'
import Configuracion from '@/components/Admin/Configuracion'
import ClienteList from '@/components/Management/ClienteList'
import PolizaList from '@/components/Management/PolizaList'
import Notificaciones from '@/components/Management/NotificacionList'
import DerivadorList from '@/components/Management/DerivadorList'
import ClientePolizaList from '@/components/Cliente/PolizaList'

import store from '@/store'

const theRouter = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: '/inicio',
      name: 'inicio',
      meta: {
        auth: false
      },
      redirect: (to) => {
        window.location.href = 'https://www.campi.net.ar'
        return '/redirecting'
      }
    },
    {
      path: '/',
      name: 'index',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: '/entrada',
      component: DashboardLayout,
      children: [
        {
          path: '/admin/dashboard',
          alias: '',
          component: DashboardView,
          name: 'secure.admin',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: 'profile',
          alias: '',
          component: ProfileView,
          name: 'profile',
          meta: {
            auth: true
          }
        },
        {
          path: '/admin/usuarios',
          alias: '',
          component: UserList,
          name: 'UserList',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/aseguradoras',
          alias: '',
          component: AseguradoraList,
          name: 'AseguradoraList',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/asesores',
          alias: '',
          component: AsesorList,
          name: 'AsesorList',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/clientes',
          alias: '',
          component: ClienteList,
          name: 'ClienteListAdmin',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/derivadores',
          alias: '',
          component: DerivadorList,
          name: 'DerivadorListAdmin',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/polizas',
          alias: '',
          component: PolizaList,
          name: 'PolizaListAdmin',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/configuracion',
          alias: '',
          component: Configuracion,
          name: 'Configuracion',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/admin/notificaciones',
          alias: '',
          component: Notificaciones,
          name: 'admin.notificaciones',
          meta: {
            auth: true,
            role: 'ADMINISTRADOR'
          }
        },
        {
          path: '/gestion/dashboard',
          alias: '',
          component: DashboardView,
          name: 'secure.gestion',
          meta: {
            auth: true,
            role: 'GESTION'
          }
        },
        {
          path: '/gestion/clientes',
          alias: '',
          component: ClienteList,
          name: 'ClienteListGestion',
          meta: {
            auth: true,
            role: 'GESTION'
          }
        },
        {
          path: '/gestion/polizas',
          alias: '',
          component: PolizaList,
          name: 'PolizaListGestion',
          meta: {
            auth: true,
            role: 'GESTION'
          }
        },
        {
          path: '/gestion/notificaciones',
          alias: '',
          component: Notificaciones,
          name: 'gestion.notificaciones',
          meta: {
            auth: true,
            role: 'GESTION'
          }
        },
        {
          path: '/cliente/dashboard',
          alias: '',
          component: DashboardView,
          name: 'secure.cliente',
          meta: {
            auth: true,
            role: 'CLIENTE'
          }
        },
        {
          path: '/cliente/polizas',
          alias: '',
          component: ClientePolizaList,
          name: 'cliente.poliza.list',
          meta: {
            auth: true,
            role: 'CLIENTE'
          }
        }
      ]
    }
  ]
})

theRouter.beforeEach((to, from, next) => {
  let user = store.getters['user/user']
  if (to.meta.auth === false) {
    return next()
  } else {
    if (user === null) {
      return next('/login')
    }
    if (to.meta.role === undefined) {
      return next()
    } else {
      if (!user.roles.includes(to.meta.role)) {
        return next('/')
      }
    }
  }
  return next()
})

Vue.use(Router)

export default theRouter



// WEBPACK FOOTER //
// ./src/router/index.js